import { Editor } from '@tiptap/core';

import { ETiptapSelectorKey } from '../../../../types/tiptap.types';
import {
  UL_PATTERNS,
  UL_PATTERN_PREVIEW,
  DEFAULT_UL_PATTERN,
  type TUlPattern,
} from '../../../../tiptap/extensions/listPatterns';
import ListSplitButton from './ListSplitButton';

const PATTERN_ITEMS = UL_PATTERNS.map((id) => ({ id, markers: UL_PATTERN_PREVIEW[id] }));

const BULLET_ICON = (
  <svg height="100%" width="100%" viewBox="0,0,2048,2048" focusable="false">
    <path
      type="path"
      style={{ fill: 'transparent' }}
      d="M 410 410 h -308 v -308 h 308 m 0 717 v 307 h -308 v -307 m 308 717 v 307 h -308 v -307 m 1844 -512 h -1229 v -102 h 1229 m 0 -717 v 102 h -1229 v -102 m 1229 1433 v 103 h -1229 v -103 z"
    ></path>
    <path
      type="path"
      style={{ fill: '#357457' }}
      d="M 410 410 h -308 v -308 h 308 m 0 717 v 307 h -308 v -307 m 308 717 v 307 h -308 v -307 z"
    ></path>
    <path
      type="path"
      style={{ fill: '#3A3A38FF' }}
      d="M 1946 1024 h -1229 v -102 h 1229 m 0 -717 v 102 h -1229 v -102 m 1229 1433 v 103 h -1229 v -103 z"
    ></path>
  </svg>
);

type TProps = {
  editor: Editor;
  menuClasses: { menu: string };
};

const BulletListButton = ({ editor, menuClasses }: TProps) => (
  <ListSplitButton
    menuClasses={menuClasses}
    selector={ETiptapSelectorKey.BULLET_LIST}
    icon={BULLET_ICON}
    tooltip="Bullets"
    chevronTooltip={{
      active: 'Bullet styles',
      inactive: 'Place the cursor in a bulleted list to change its style.',
    }}
    onToggle={() => editor.chain().focus().toggleBulletList().run()}
    disabled={(e) => e.isActive(ETiptapSelectorKey.HEADING) || !e.can().chain().focus().toggleBulletList().run()}
    patterns={PATTERN_ITEMS}
    defaultPattern={DEFAULT_UL_PATTERN}
    onSelectPattern={(pattern) =>
      editor
        .chain()
        .focus()
        .setBulletListPattern(pattern as TUlPattern | null)
        .run()
    }
  />
);

export default BulletListButton;
